import React, { useEffect, useState } from "react";
import {Scoodle2FASetupConfirm, IAccountData} from "../../../components/05pages/scoodle/Scoodle2FASetup/Scoodle2FASetupConfirm";
import { ScoodleDefaultPage } from "../../../components/04templates/scoodle/defaultPage/ScoodleDefaultPage";
import { Link } from "pu-crossproduct-components/build/components/Molecules/Navigation/Link";
import { useTranslation } from "react-i18next";

const defaultAccountData = {
    givenName: "",
    familyName: "",
    emailAddress: "",
    acmGivenName: "",
    acmFamilyName: ""
};

interface IState {
    isLoading: boolean;
    isError: boolean;
    errorMessage: string;
    accountData: IAccountData;
}

export const Scoodle2FASetupConfirmPage : React.FC = props => {
    const [state, setState] = useState<IState>({
        isLoading: true,
        isError: false,
        errorMessage: "",
        accountData: defaultAccountData
    });
    const {t} = useTranslation();

    const handleError = (e: any) => {
        setState({...state, isError: true, isLoading: false, accountData: defaultAccountData, errorMessage: JSON.stringify(e)})
        console.error(JSON.stringify(e));
    }

    const handleDataLoaded = (data: IAccountData) => {
        setState({...state, isError: false, isLoading: false, accountData: data, errorMessage: JSON.stringify("")})
    }

    // Data Loader
    useEffect(() => {(async () => {
        try {
            const response = await fetch('/Scoodle2FA/SetupConfirmAccountData')
            if (response.ok) {
                // Server returned Ok -> Fetching data
                const data = (await response.json()) as IAccountData;
                handleDataLoaded(data);
            } else {
                // Server returned an error
                handleError(response.body)
            }
        } catch (e) {
            // Something went very wrong
            handleError(e.message);
        }
    })()}, []);

    if (state.isLoading)
        return <ScoodleDefaultPage>Loading ...</ScoodleDefaultPage>;

    if (state.isError)
        return <ScoodleDefaultPage>
            <div style={{color: "red"}}>{t('twoFactorScoodleGeneralErrorTitle')}</div><br />
            <p>{t('twoFactorScoodleGeneralErrorDescription')}</p>
            <br />
            <Link href="https://www.scoodle.be">{t('twoFactorScoodleGeneralErrorRetryButton')}</Link>
        </ScoodleDefaultPage>;

    return <Scoodle2FASetupConfirm
        accountData={state.accountData}
        onConfirm={() => window.location.href = "/Scoodle2FA/SetupConfirmConfirm" }
        onReject={() => window.location.href = "/Scoodle2FA/SetupConfirmReject" } />
}